import { Col, Row } from "react-bootstrap";

import { Chapter } from "../../components/Chapter";
import React from 'react'
import {
  useParams
} from "react-router-dom";

export const Vineyards = () => {
  let { nome } = useParams();
  React.useEffect(() => {
    if (nome) {
      const ele = document.getElementById(nome);
      const navHeight = window.innerHeight *0.15;
      window.scrollTo(ele.offsetLeft, ele.offsetTop-navHeight);
    }
  },)

  const chapters = [
    {
      name: "sialic",
      title: "Vigneto Sialic",
      text: "Il vigneto rappresenta uno dei gioielli dei nostri terreni. Situato su ripidi pendii terrazzati a un'altitudine di circa 600 metri sul livello del mare, questo vigneto nato nel 2016 occupa una superficie di circa 1 ettaro ed è piantato con 2500 viti di Sauvignon Blanc.Le profonde radici delle viti penetrano un sottosuolo ricco di rocce sialitiche, conferendo alle uve un carattere distintivo. L'esposizione a sud garantisce un'abbondante luce solare, mentre gli sbalzi termici tra il giorno e la notte enfatizzano i profumi unici delle uve. Incorniciato da boschi e montagne, questo vigneto dà origine alle uve di Sauvignon Blanc, che costituiscono la base per il nostro vino Sialic.",
      image: "/images/vineyards/sialic.jpg",
      buttons: [{
        link: "https://www.google.com/maps/d/edit?mid=1NLLZMyzg_hzIW1178RiYSr_U3bpQNwI&usp=sharing",
        bText: 'Mappa Vigneto'
      }]

    },
    {
      name: "bram",
      title: "Vigneto Bram",
      text: "Nascosto ai piedi dell' imponente Monte Viso, il vigneto si estende con grazia su una leggera pendenza, abbracciando un'area che copre l'equivalente di una giornata piemontese. In questo luogo coltiviamo con cura e dedizione 2000 viti di Pinot Nero, seguendo il sistema di potatura a guyot. Questo vigneto è posizionato nelle immediate vicinanze della storica vigna del Brichet. Da qui, gli occhi sono catturati da una vista panoramica che abbraccia l'iconica Rocca di Cavour, creando un connubio perfetto tra viticoltura e paesaggio. La storia di questo vigneto inizia nel 2017, quando abbiamo deciso di esplorare ulteriormente le potenzialità vinicole della nostra terra, piantando le prime viti di Pinot Nero. È da queste viti che nascono le uve del nostro Bram, una nuova tappa coinvolgente nella nostra ricerca per la creazione di vini di qualità.",
      image: "/images/vineyards/bram.jpg",
      buttons: [{
        link: "https://www.google.com/maps/d/edit?mid=1Xg5-_euegGJajsHbspBcfrL_qDXcQKI&usp=sharing",
        bText: 'Mappa Vigneto'
      }]
    },
    {
      name: "brichet",
      title: "Vigneto Brichet",
      text: "Luogo dove la tradizione vinicola si fonde con le caratteristiche uniche del terroir, il vigneto si stende su una leggera pendenza che abbraccia un'area di circa mezzo ettaro. Questo vecchio vigneto fu piantato nel '60 da Agù Costanzo, rispecchiando le consuetudini di quell'epoca. Il vigneto ospita circa 3000 viti, seguendo la tradizionale pratica di coltivare una vasta gamma di varietà per soddisfare le preferenze personali del proprietario. Tra le varietà coltivate figurano la Barbera, la Bonarda, il Dolcetto, la Freisa, ma anche varietà a bacca bianca come Moscato e Arneis. Queste vecchie viti, producono le uve che costituiscono il cuore del Brichet, un vino che riflette l'anima di questo vigneto. Questo vigneto è un fedele custode della storia e dell'arte vinicola della nostra famiglia.",
      image: "/images/vineyards/brichet.jpg",
      buttons: [{
        link: "https://www.google.com/maps/d/edit?mid=1V_S0qRc1beZb3m5nPikZc7-y2rM4DkY&usp=sharing",
        bText: 'Mappa Vigneto'
      }]
    },

  ];

  return (<>
    <Row>
      <Col md={12} className="text-center" >
        <h2>I Nostri Vigneti: Il Cuore dell'Azienda<br /><small>&quot;il vino si fa in vigna, non in cantina.&quot;</small></h2>

      </Col>
    </Row>
    <Row style={{ padding: '10vh' }}>
      <Col md={12} className="text-center" >
        <p>
          I nostri vigneti rappresentano il cuore pulsante dell'Azienda Vitivinicola Agù. La filosofia che guida la nostra coltivazione è quella del rispetto per la natura e dell'amore per la terra. Applichiamo metodi di coltivazione naturale, limitando i trattamenti a soli rame e zolfo, in sintonia con l'ambiente circostante.
          La copertura del suolo con inerbimento, la rinuncia a sostanze chimiche di sintesi e l'incoraggiamento della crescita radicale profonda sono parte integrante della nostra pratica viticola. Questi sforzi ci permettono di produrre uve di alta qualità, ricche di carattere e sfumature, e di tradurre il terroir unico del nostro territorio nei nostri vini.
          I nostri vigneti sono un ambiente vibrante di biodiversità, dove viti,  piante autoctone, insetti benefici e animali selvatici convivono in armonia. Questa ricca biodiversità è fondamentale per il nostro approccio sostenibile alla viticoltura.
        </p>
      </Col>
    </Row>
    {chapters.map((chapter, index) => (
      <Chapter
        key={index}
        chapter={chapter}
        index={index}
        startBlack={true} />
    ))}



  </>)
}